(() => {
  const bannerSelector = '[data-scrolling-banner]';
  const videoSelector = '[data-scrolling-video]';
  const frameSelector = '[data-scrolling-frame]';
  const frameImageSelector = '[data-frame-image]';
  const maskSelector = '[data-scrolling-mask]';
  const containers = document.querySelectorAll(bannerSelector);
  const viewportHeight = () => window.innerHeight || document.documentElement.clientHeight;
  const isDesktop = () => window.innerWidth >= 900;
  const inViewport = (el, full = true) => {
    let rect = el.getBoundingClientRect(), vh = viewportHeight();
    return (full ? (rect.top >= 0 && rect.bottom <= vh) : (rect.top < vh && rect.bottom >= 0));
  }

  const once = (el, event, fn, opts) => {
    let onceFn = function (e) {
      el.removeEventListener(event, onceFn);
      fn.apply(this, arguments);
    };
    el.addEventListener(event, onceFn, opts);
    return onceFn;
  }

  if (containers) {
    containers.forEach((container, index) => {
      const containerHeight = () => container.offsetHeight;
      const start = () => container.offsetTop;
      const end = () => start() + containerHeight();

      const arrowScroll = container.querySelector('.banner_scroll');
      const handleArrowScroll = () => arrowScroll.style.opacity = (window.scrollY > 0) ? '0' : '1';
      const video = container.querySelector(videoSelector);
      const stickyEl = video.parentNode;
      let videoInit = false;
      let imagesInit = false;
      const reInitLoader = () => {
        if (!imagesInit || !videoInit) stickyEl.classList.remove('ready');
        setTimeout(() => stickyEl.classList.add('ready'), 1000);
      }
      const handleFrameScroll = (frame, index) => {
        let active = inViewport(frame);
        frame.classList.toggle('is-visible', active);
        active && !isDesktop() && showSlide(index);
      }

      const frames = container.querySelectorAll(frameSelector);
      const framesSlides = container.querySelectorAll(frameImageSelector);
      let currentSlide = 0;
      const showSlide = (current) => {
        if (currentSlide === current) return;

        framesSlides.forEach(image => {
          image.classList.remove('active');
        });

        framesSlides[current].classList.add('active');

        currentSlide = current;
      }

      arrowScroll && window.addEventListener('scroll', () => handleArrowScroll(), { passive: true });

      frames && frames.forEach((frame, index) => {
        handleFrameScroll(frame, index);
        window.addEventListener('scroll', () => handleFrameScroll(frame, index), { passive: true });
      });

      const initVideo = (resize) => {
        resize && reInitLoader();
        if (!isDesktop() || videoInit || !video) return;
        videoInit = true;
        console.log('video ', video.dataset?.videoId, 'initialized');

        let source = video.querySelector('source');
        let src = source.dataset.src;
        source.src = src;
        window['fetch'] && fetch(src)
          .then((response) => response.blob())
          .then((response) => {
            let blobURL = URL.createObjectURL(response);
            console.log('video ', video.dataset?.videoId, ' fetched');
            let t = video.currentTime;
            once(document.documentElement, 'touchstart', () => {
              video.play();
              video.pause();
            });

            video.setAttribute('src', blobURL);
            video.currentTime = t + 0.01;

            stickyEl.classList.add('ready');
            handleVideoScroll(container);
          });

        let videoDuration = 5;
        let cmsDuration = !isNaN(parseFloat(video.dataset.duration)) && parseFloat(video.dataset.duration);
        let currentTime = 0;

        let handleVideoScroll = (element) => {
          if (!isDesktop()) return;
          let scrollY = window.scrollY;

          if (inViewport(element, false) && (scrollY > start() && scrollY + viewportHeight() < end())) {
            let scrolled = ((scrollY - start()) / (containerHeight() - viewportHeight()));
            currentTime = videoDuration * scrolled;

            if (currentTime >= videoDuration) return;
            video.currentTime = currentTime;
            video.style.objectPosition = '50% ' + 100 * scrolled + '%';
          } else if (scrollY + viewportHeight() > end()) {
            video.currentTime = videoDuration;
            video.style.objectPosition = '50% 100%';
          } else {
            video.currentTime = 0;
            video.style.objectPosition = '50% 0%';
          }
        }

        once(video, 'loadeddata', () => {
          videoDuration = cmsDuration || video.duration;
          video.currentTime = 0.01;

          console.log('loadeddata id = ', video.dataset?.videoId);
          console.log('duration = ', video.duration, 'cms duration = ', cmsDuration);
          console.log('current duration = ', videoDuration);

          /* Make sure the video is 'activated' on iOS */
          once(document.documentElement, 'touchstart', () => {
            video.play();
            video.pause();
          });

          handleVideoScroll(container);
          window.addEventListener('scroll', () => handleVideoScroll(container), { passive: true });
          window.addEventListener('resize', () => handleVideoScroll(container), { passive: true });
        }, false);
      }

      // START of Mask
      let scrollMask = container.querySelector(maskSelector);

      if (scrollMask) {
        let maskClass = scrollMask.classList;
        let max = parseInt(scrollMask.dataset.maskOffset) || 150;

        const setMaskOffset = (offset) => container.style.setProperty('--mask-offset', `${offset}px`);

        const handleScrollMask = (el) => {
          let scrollY = window.scrollY;
          let rectTop = el.getBoundingClientRect().top;
          let vh = viewportHeight();
          let way = (vh / 2);
          let top = (scrollY + vh) > start() && start() > scrollY;
          let bottom = (scrollY + vh) > end() && (end() + vh) > scrollY;
          let progressTop = ((way - (rectTop / 2)) / way) * 100;
          let progressBottom = ((way - ((rectTop + el.offsetHeight) / 2)) / way) * 100;

          maskClass.toggle('active-top', top);
          maskClass.toggle('active-bottom', bottom);

          if (top && !bottom && index !== 0) {
            let top = max - ((max / 100) * progressTop);

            if (top <= max) {
              setMaskOffset(top);
            } else {
              setMaskOffset(max);
              return;
            }
          }

          if (bottom && !top) {
            let bottom = (max / 100) * progressBottom;

            if (bottom >= max) {
              setMaskOffset(max);
              return;
            } else {
              setMaskOffset(bottom);
            }
          }

          !bottom && !top && setMaskOffset(0);
        }

        handleScrollMask(container);

        document.addEventListener('DOMContentLoaded', () => {
          window.addEventListener('resize', () => handleScrollMask(container), { passive: true });
          window.addEventListener('scroll', () => handleScrollMask(container), { passive: true });
        });
      }
      // END of Mask

      const initImages = (resize) => {
        resize && reInitLoader();
        if (isDesktop() || imagesInit || (!framesSlides)) return;
        imagesInit = true;
        console.log('images ', video.dataset?.videoId, 'initialized');

        framesSlides.forEach(slide => {
          let img = slide.querySelector('img');
          img.src = img.dataset.src
        });

        once(document, 'readystatechange', e => e.target.readyState === 'complete' && stickyEl.classList.add('ready'));
      }

      document.addEventListener('DOMContentLoaded', () => {
        initImages();
        initVideo();

        window.addEventListener('resize', () => {
          initImages(true);
          initVideo(true);
        });
      });
    })
  }
})();
